module.exports = __webpack_public_path__ + "static/roman_legion.05709897.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Location/roman_legion.png
// module id = 702
// module chunks = 213534597649335